import { observer } from 'mobx-react';
import * as React from 'react';
import {
  handleEnterKeyPress,
  handleEscKeyDown,
} from '../../../../../../Accessibility/KeyboardEvents';
import clickOutsideStore from '../../../../../../ClickOutsideStore';
import { useOpenable } from '../../../../../Modal/UseOpenable';
import Content from './Content';
import { fromNullable } from 'maybeasy';
import { warn } from '@execonline-inc/logging';

export interface Props {
  icon: React.JSX.Element;
  content: React.JSX.Element;
}

const Popover: React.FC<Props> = ({ icon, content }) => {
  const actionItemsRef = React.useRef<HTMLDivElement | null>(null);
  const { modalState, open, close } = useOpenable();

  const openWithListener = () => {
    fromNullable(actionItemsRef)
      .do(() => clickOutsideStore.addListener({ ref: actionItemsRef, callback: close }))
      .elseDo(() => warn(`Element not found. Modal may not work`));
    open();
  };

  switch (modalState.kind) {
    case 'open':
      return (
        <div
          onClick={close}
          ref={actionItemsRef}
          data-test-actionitems={true}
          id="popover-container"
          tabIndex={-1}
          className="relative"
        >
          <div
            data-test-dropdown-header={icon}
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(close)}
            onKeyDown={handleEscKeyDown(close)}
            className="cursor-pointer relative"
          >
            {icon}
          </div>
          <Content content={content} modalState={modalState} />
        </div>
      );
    case 'closed':
      return (
        <div
          onClick={openWithListener}
          ref={actionItemsRef}
          data-test-actionitems={true}
          id="popover-container"
          tabIndex={-1}
          className="relative"
        >
          <div
            data-test-dropdown-header={icon}
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(openWithListener)}
            onKeyDown={handleEscKeyDown(close)}
            className="cursor-pointer relative"
          >
            {icon}
          </div>
          <Content content={content} modalState={modalState} />
        </div>
      );
  }
};

export default observer(Popover);
